import FormSociedades from '../componentes/FormSociedades.vue'
import ListaSociedades from '../componentes/ListaSociedades.vue'


const routes = [
    ...route('/guardar-sociedad', FormSociedades, {
        Auth: true,
        ///req_admin: true
     }),
     ...route('/lista-sociedades', ListaSociedades, {
       Auth: true,
       //req_admin: true
    }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes